import { atom } from 'recoil'
import { IFaqArticleSearchTag } from '../../faq.types'
import recoilUrlSyncEffectGenerator from '../../../../../recoil/recoil.urlSyncEffect.generator'

interface IArticleSearchTagsState {
  items: IFaqArticleSearchTag[]
  loaded: boolean
  filters: {
    search: string
    forceReload: number
  }
}

export const articleSearchTagsAtomInitialState: IArticleSearchTagsState = {
  items: [],
  loaded: false,
  filters: {
    search: '',
    forceReload: 0,
  },
}

const articleSearchTagsAtom = atom<IArticleSearchTagsState>({
  key: 'etb/faq/articleSearchTags',
  default: articleSearchTagsAtomInitialState,
  effects: [
    recoilUrlSyncEffectGenerator.generate([
      {
        key: 'filters',
        type: 'object',
        children: [{ key: 'search', type: 'string' }],
      },
    ]),
  ],
})
export default articleSearchTagsAtom
